import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'

export const calcImageScale = (containerWidth, imageWidth) => {
  if (!imageWidth || !containerWidth) {
    return 1
  }

  return containerWidth < imageWidth ? containerWidth / imageWidth : 1
}

export const getImageAssetUrl = (path, options = {}) => {
  const params = {
    filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
    width: options.width || 1500,
    height: options.height || 1500,
    path,
    backgroundColor: 'white',
    ...options
  }

  return getImageAssetPath(params)
}
